import React, { useState } from 'react';
import styles from './S2.module.css';
import Video1 from './videos/Reloj.mp4'; 
import Video2 from './videos/Agenda.mp4';
import Video3 from './videos/interfaz.mp4';
import Video4 from './videos/Personalizacion.mp4';
import Video5 from './videos/R.neuronal.mp4'; 
import Video6 from './videos/Mejora.mp4';
import Logo from './images/LogoCabezaBlancoSinFondo(48px).png';

const Seccion2 = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredCard(index);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  const videos = [
    { src: Video1, title: "Funcionamiento 24/7" },
    { src: Video2, title: "Gestión de agenda" },
    { src: Video3, title: "Interfaz intuitiva" },
    { src: Video4, title: "Hiper-personalización" },
    { src: Video5, title: "Tecnología de Redes Neuronales" },
    { src: Video6, title: "Mejora Continua" },
  ];

  return (
    <section className={styles.section}>
      <h1 className={styles.heading}>Beneficios</h1>
      <div className={styles.container}>
        {videos.map((video, index) => (
          <div
            key={index}
            className={`${styles.card} ${hoveredCard === index ? styles.active : ''}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <video 
              src={video.src} 
              autoPlay 
              loop 
              muted
              playsInline
              className={styles.background} 
            />
            <div className={styles.cardContent}>
              <div className={styles.profileImage}>
                <img src={Logo} alt="Logo" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
              </div>
              <h3 className={styles.title}>{video.title}</h3>
            </div>
            <div className={styles.backdrop}></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Seccion2;
